import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';
import { generateRandom } from '../../helpers/utility';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_PROPERTY_REDUX]'; // eslint-disable-line

const functionDefinitions = {

    /*---------- propertyAction --------*/
    requestPropertyActions: ['propertyId'],
    propertyActionsSuccess: ['propertyActionsResponse'],
    propertyActionsFailure: ['propertyActionsError'],

    /*---------- getLatestPropertiesView --------*/
    requestGetLatestPropertiesView: ['userId'],
    getLatestPropertiesViewSuccess: ['getLatestPropertiesViewResponse'],
    getLatestPropertiesViewFailure: ['getLatestPropertiesViewError'],

    /*---------- updatePropertyStatus --------*/
    requestUpdatePropertyStatus: ['propertyId', 'status', 'userId'],
    updatePropertyStatusSuccess: ['updatePropertyStatusResponse'],
    updatePropertyStatusFailure: ['updatePropertyStatusError'],

    /*---------- getPropertyDescription --------*/
    requestGetPropertyDescription: ['propertyId', 'userId'],
    getPropertyDescriptionSuccess: ['getPropertyDescriptionResponse'],
    getPropertyDescriptionFailure: ['getPropertyDescriptionError'],

    /*---------- updateStandardText --------*/
    requestUpdateStandardText: ['standardText', 'userId', 'propertyId'],
    updateStandardTextSuccess: ['updateStandardTextResponse'],
    updateStandardTextFailure: ['updateStandardTextError'],

    /*---------- updatePropertyDescription --------*/
    requestUpdatePropertyDescription: ['propertyDescription', 'userId'],
    updatePropertyDescriptionSuccess: ['updatePropertyDescriptionResponse'],
    updatePropertyDescriptionFailure: ['updatePropertyDescriptionError'],

    /*---------- getPropertyList --------*/
    requestGetPropertyList: ['userId'],
    getPropertyListSuccess: ['getPropertyListResponse'],
    getPropertyListFailure: ['getPropertyListError'],

    /*---------- generatePropertyListReport --------*/
    requestGeneratePropertyListReport: ['propertyIds', 'userId'],
    generatePropertyListReportSuccess: ['generatePropertyListReportResponse'],
    generatePropertyListReportFailure: ['generatePropertyListReportError'],

    /*---------- updateBatchPropertyList --------*/
    requestUpdateBatchPropertyList: ['batchProperty'],
    updateBatchPropertyListSuccess: ['updateBatchPropertyListResponse'],
    updateBatchPropertyListFailure: ['updateBatchPropertyListError'],

    /*---------- getPropertyDetail --------*/
    requestGetPropertyDetail: ['propertyId', 'userId', 'category'],
    getPropertyDetailSuccess: ['getPropertyDetailResponse'],
    getPropertyDetailFailure: ['getPropertyDetailError'],

    /*---------- getProjectUnits --------*/
    requestGetProjectUnits: ['projectId'],
    getProjectUnitsSuccess: ['getProjectUnitsResponse'],
    getProjectUnitsFailure: ['getProjectUnitsError'],

    /*---------- updateProperty --------*/
    requestUpdateProperty: ['propertyDetail', 'userId'],
    updatePropertySuccess: ['updatePropertyResponse'],
    updatePropertyFailure: ['updatePropertyError'],

    /*---------- updatePropertySendToWeb --------*/
    requestUpdatePropertySendToWeb: ['propertyId', 'isOnWeb', 'userId'],
    updatePropertySendToWebSuccess: ['updatePropertySendToWebResponse'],
    updatePropertySendToWebFailure: ['updatePropertySendToWebError'],

    /*---------- updatePortalSenderForProperty --------*/
    requestUpdatePortalSenderForProperty: ['propertyId', 'portalId', 'userId', 'isSelected'],
    updatePortalSenderForPropertySuccess: ['updatePortalSenderForPropertyResponse'],
    updatePortalSenderForPropertyFailure: ['updatePortalSenderForPropertyError'],

    /*---------- updatePropertyArchive --------*/
    requestUpdatePropertyArchive: ['propertyId', 'userId'],
    updatePropertyArchiveSuccess: ['updatePropertyArchiveResponse'],
    updatePropertyArchiveFailure: ['updatePropertyArchiveError'],

    /*---------- deleteProperty --------*/
    requestDeleteProperty: ['propertyId', 'userId'],
    deletePropertySuccess: ['deletePropertyResponse'],
    deletePropertyFailure: ['deletePropertyError'],

    /*---------- generateDynamicPropertyReport --------*/
    requestGenerateDynamicPropertyReport: ['reportId', 'methodName', 'propertyId'],
    generateDynamicPropertyReportSuccess: ['generateDynamicPropertyReportResponse'],
    generateDynamicPropertyReportFailure: ['generateDynamicPropertyReportError'],

    /*---------- getPropertyPicturesAndFiles --------*/
    requestGetPropertyPicturesAndFiles: ['propertyId', 'userId'],
    getPropertyPicturesAndFilesSuccess: ['getPropertyPicturesAndFilesResponse'],
    getPropertyPicturesAndFilesFailure: ['getPropertyPicturesAndFilesError'],

    /*---------- updateWaterMarkSetting --------*/
    requestUpdateWaterMarkSetting: ['propertyId', 'userId', 'watermarkSetting'],
    updateWaterMarkSettingSuccess: ['updateWaterMarkSettingResponse'],
    updateWaterMarkSettingFailure: ['updateWaterMarkSettingError'],

    /*---------- getPropertyPicturesWithWaterMark --------*/
    requestGetPropertyPicturesWithWaterMark: ['propertyId', 'userId'],
    getPropertyPicturesWithWaterMarkSuccess: ['getPropertyPicturesWithWaterMarkResponse'],
    getPropertyPicturesWithWaterMarkFailure: ['getPropertyPicturesWithWaterMarkError'],

    /*---------- updatePropertyPicturesAndFiles --------*/
    requestUpdatePropertyPicturesAndFiles: ['propertyId', 'userId', 'pictureAndFiles'],
    updatePropertyPicturesAndFilesSuccess: ['updatePropertyPicturesAndFilesResponse'],
    updatePropertyPicturesAndFilesFailure: ['updatePropertyPicturesAndFilesError'],

    /*---------- rotatePropertyPictures --------*/
    requestRotatePropertyPictures: ['propertyId', 'userId', 'angle', 'pictureIds'],
    rotatePropertyPicturesSuccess: ['rotatePropertyPicturesResponse'],
    rotatePropertyPicturesFailure: ['rotatePropertyPicturesError'],

    /*---------- updateCategory --------*/
    requestUpdateCategory: ['propertyId', 'userId'],
    updateCategorySuccess: ['updateCategoryResponse'],
    updateCategoryFailure: ['updateCategoryError'],

    /*---------- convertPropertyType --------*/
    requestConvertPropertyType: ['propertyId', 'userId', 'propertyTypeId'],
    convertPropertyTypeSuccess: ['convertPropertyTypeResponse'],
    convertPropertyTypeFailure: ['convertPropertyTypeError'],

    /*---------- duplicateProperty --------*/
    requestDuplicateProperty: ['propertyId', 'userId'],
    duplicatePropertySuccess: ['duplicatePropertyResponse'],
    duplicatePropertyFailure: ['duplicatePropertyError'],

    /*---------- getOwnersInformation --------*/
    requestGetOwnersInformation: ['propertyId', 'userId'],
    getOwnersInformationSuccess: ['getOwnersInformationResponse'],
    getOwnersInformationFailure: ['getOwnersInformationError'],

    /*---------- updateOwnersInformation --------*/
    requestUpdateOwnersInformation: ['sellerOrBuyerInformation', 'propertyId', 'userId'],
    updateOwnersInformationSuccess: ['updateOwnersInformationResponse'],
    updateOwnersInformationFailure: ['updateOwnersInformationError'],

    /*---------- getPropertyActivityLogs --------*/
    requestGetPropertyActivityLogs: ['propertyId'],
    getPropertyActivityLogsSuccess: ['getPropertyActivityLogsResponse'],
    getPropertyActivityLogsFailure: ['getPropertyActivityLogsError'],

    /*---------- createOrUpdatePropertyActivityLog --------*/
    requestCreateOrUpdatePropertyActivityLog: ['propertyActivityDetail'],
    createOrUpdatePropertyActivityLogSuccess: ['createOrUpdatePropertyActivityLogResponse'],
    createOrUpdatePropertyActivityLogFailure: ['createOrUpdatePropertyActivityLogError'],

    /*---------- removePropertyActivityLog --------*/
    requestRemovePropertyActivityLog: ['activityLogId', 'propertyId'],
    removePropertyActivityLogSuccess: ['removePropertyActivityLogResponse'],
    removePropertyActivityLogFailure: ['removePropertyActivityLogError'],

    /*---------- getpropertyPortals --------*/
    requestGetpropertyPortals: ['propertyId'],
    getpropertyPortalsSuccess: ['getpropertyPortalsResponse'],
    getpropertyPortalsFailure: ['getpropertyPortalsError'],

    /*---------- getFmrDetailResponse --------*/
    requestGetFmrDetailResponse: ['mainRegId'],
    getFmrDetailResponseSuccess: ['getFmrDetailResponseResponse'],
    getFmrDetailResponseFailure: ['getFmrDetailResponseError'],

    /*---------- getPropertyDocument --------*/

    requestGetPropertyDocument: ['propertyId'],
    getPropertyDocumentSuccess: ['getPropertyDocumentResponse'],
    getPropertyDocumentFailure: ['getPropertyDocumentError'],

    /*---------- updatePropertyDocument --------*/

    requestUpdatePropertyDocument: ['propertyId', 'documents'],
    updatePropertyDocumentSuccess: ['updatePropertyDocumentResponse'],
    updatePropertyDocumentFailure: ['updatePropertyDocumentError'],

    /*---------- removeDocument --------*/

    requestRemoveDocument: ['propertyId', 'referenceId', 'actionId', 'documentType'],
    removeDocumentSuccess: ['removeDocumentResponse'],
    removeDocumentFailure: ['removeDocumentError'],

    /*---------- duplicateOffer --------*/

    requestDuplicateOffer: ['propertyId', 'offerId'],
    duplicateOfferSuccess: ['duplicateOfferResponse'],
    duplicateOfferFailure: ['duplicateOfferError'],

    /*---------- downloadPropertyFile --------*/

    requestDownloadPropertyFile: ['propertyFileId'],
    downloadPropertyFileSuccess: ['downloadPropertyFileResponse'],
    downloadPropertyFileFailure: ['downloadPropertyFileError'],

    /*---------- getpropertyHistories --------*/
    requestGetpropertyHistories: ['propertyId'],
    getpropertyHistoriesSuccess: ['getpropertyHistoriesResponse'],
    getpropertyHistoriesFailure: ['getpropertyHistoriesError'],

    /*---------- restorePropertyHistory --------*/
    requestRestorePropertyHistory: ['propertyId', 'propertyShwId', 'userId'],
    restorePropertyHistorySuccess: ['restorePropertyHistoryResponse'],
    restorePropertyHistoryFailure: ['restorePropertyHistoryError'],

    /*---------- getPropertyLoans --------*/

    requestGetPropertyLoans: ['propertyId'],
    getPropertyLoansSuccess: ['getPropertyLoansResponse'],
    getPropertyLoansFailure: ['getPropertyLoansError'],

    /*---------- getPropertyLoanDetail --------*/

    requestGetPropertyLoanDetail: ['propertyId', 'loanId'],
    getPropertyLoanDetailSuccess: ['getPropertyLoanDetailResponse'],
    getPropertyLoanDetailFailure: ['getPropertyLoanDetailError'],

    /*---------- savePropertyLoan --------*/

    requestSavePropertyLoan: ['propertyId', 'mortgage'],
    savePropertyLoanSuccess: ['savePropertyLoanResponse'],
    savePropertyLoanFailure: ['savePropertyLoanError'],

    /*---------- removePropertyLoan --------*/

    requestRemovePropertyLoan: ['propertyId', 'loanId'],
    removePropertyLoanSuccess: ['removePropertyLoanResponse'],
    removePropertyLoanFailure: ['removePropertyLoanError'],

    /*---------- updatePropertyLoanIsSent --------*/

    requestUpdatePropertyLoanIsSent: ['propertyId', 'loanId', 'isSent'],
    updatePropertyLoanIsSentSuccess: ['updatePropertyLoanIsSentResponse'],
    updatePropertyLoanIsSentFailure: ['updatePropertyLoanIsSentError'],

    /*---------- addPropertyViews --------*/

    requestAddPropertyViews: ['userId', 'propertyId'],
    addPropertyViewsSuccess: ['addPropertyViewsResponse'],
    addPropertyViewsFailure: ['addPropertyViewsError'],

    /*---------- downloadPropertyPictures --------*/

    requestDownloadPropertyPictures: ['propertyId', 'propertyPictureIds'],
    downloadPropertyPicturesSuccess: ['downloadPropertyPicturesResponse'],
    downloadPropertyPicturesFailure: ['downloadPropertyPicturesError'],

};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaPropertyTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaPropertyInitState = {
    propertyActions: []
};

export const INITIAL_STATE = Immutable(SagaPropertyInitState);

/* ------------- Reducers ------------- */

/*---------- propertyActions --------*/
export const requestPropertyActions = (state, action) => {
    return state.merge({
        propertyActionsFetching: true,
        propertyId: action.propertyId,
        propertyActionsError: null
    });
};
export const propertyActionsSuccess = (state, action) => {
    return state.merge({
        propertyActionsFetching: false,
        propertyActionsResponse: action.propertyActionsResponse,
        propertyActionsError: null // if success, then set error to be NULL
    });
};
export const propertyActionsFailure = (state, action) => {
    return state.merge({
        propertyActionsFetching: false,
        propertyActionsError: action.propertyActionsError
        // do not set payload to be null, as it will cause your UI to go empty
    });
};

/*---------- getLatestPropertiesView --------*/
export const requestGetLatestPropertiesView = (state, action) => {
    return state.merge(
        {
            getLatestPropertiesViewFetching: true,
            userId: action.userId,
            getLatestPropertiesViewError: null,
        });
};
export const getLatestPropertiesViewSuccess = (state, action) => {
    return state.merge(
        {
            getLatestPropertiesViewFetching: false,
            getLatestPropertiesViewResponse: action.getLatestPropertiesViewResponse,

        });
};
export const getLatestPropertiesViewFailure = (state, action) => {
    return state.merge(
        {
            getLatestPropertiesViewFetching: false,
            getLatestPropertiesViewError: action.getLatestPropertiesViewError,

        });
};

/*---------- updatePropertyStatus --------*/
export const requestUpdatePropertyStatus = (state, action) => {
    return state.merge(
        {
            getLatestPropertiesViewFetching: true,
            propertyId: action.propertyId,
            status: action.status,
            userId: action.userId,
            updatePropertyStatusError: null,
        });
};
export const updatePropertyStatusSuccess = (state, action) => {
    return state.merge(
        {
            getLatestPropertiesViewFetching: false,
            updatePropertyStatusResponse: action.updatePropertyStatusResponse,
        });
};
export const updatePropertyStatusFailure = (state, action) => {
    return state.merge(
        {
            getLatestPropertiesViewFetching: false,
            updatePropertyStatusError: action.updatePropertyStatusError,
        });
};

/*---------- getPropertyDescription --------*/

export const requestGetPropertyDescription = (state, action) => {
    return state.merge(
        {
            getPropertyDescriptionFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
            getPropertyDescriptionResponse: null,
            getPropertyDescriptionError: null,
            updatePropertyDescriptionError: null,
            updateStandardTextResponse: null,
            updatePropertyDescriptionResponse: null,
        });
};
export const getPropertyDescriptionSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyDescriptionFetching: false,
            getPropertyDescriptionResponse: action.getPropertyDescriptionResponse
        });
};
export const getPropertyDescriptionFailure = (state, action) => {
    return state.merge(
        {
            getPropertyDescriptionFetching: false,
            getPropertyDescriptionError: action.getPropertyDescriptionError,
        });
};

/*---------- updateStandardText --------*/
export const requestUpdateStandardText = (state, action) => {
    return state.merge(
        {
            updateStandardTextFetching: true,
            standardText: action.standardText,
            userId: action.userId,
            propertyId: action.propertyId,
            updateStandardTextError: null,
            updateStandardTextResponse: null,
        });
};
export const updateStandardTextSuccess = (state, action) => {
    return state.merge(
        {
            updateStandardTextFetching: false,
            updateStandardTextResponse: action.updateStandardTextResponse,
        });
};
export const updateStandardTextFailure = (state, action) => {
    return state.merge(
        {
            updateStandardTextFetching: false,
            updateStandardTextError: action.updateStandardTextError,
        });
};

/*---------- updatePropertyDescription --------*/

export const requestUpdatePropertyDescription = (state, action) => {

    return state.merge(
        {
            updatePropertyDescriptionFetching: true,
            propertyDescription: action.propertyDescription,
            userId: action.userId,
            updatePropertyDescriptionResponse: null,
            updatePropertyDescriptionError: null,
        });
};
export const updatePropertyDescriptionSuccess = (state, action) => {
    const getPropertyDetailResponse = (state.getPropertyDetailResponse) ? Immutable.asMutable(state.getPropertyDetailResponse, { deep: true }) : null;
    if (getPropertyDetailResponse && getPropertyDetailResponse.propertyDetail) {
        getPropertyDetailResponse.propertyDetail.portals = action.updatePropertyDescriptionResponse.propertyPortals;
        getPropertyDetailResponse.propertyDetail.sentToWeb = action.updatePropertyDescriptionResponse.sentToWeb;
    }
    return state.merge(
        {
            updatePropertyDescriptionFetching: false,
            updatePropertyDescriptionResponse: action.updatePropertyDescriptionResponse,
            getPropertyDetailResponse
        });
};
export const updatePropertyDescriptionFailure = (state, action) => {
    return state.merge(
        {
            updatePropertyDescriptionFetching: false,
            updatePropertyDescriptionError: action.updatePropertyDescriptionError,
        });
};

/*---------- getPropertyList --------*/
export const requestGetPropertyList = (state, action) => {
    return state.merge(
        {
            getPropertyListFetching: true,
            userId: action.userId
        });
};
export const getPropertyListSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyListFetching: false,
            getPropertyListResponse: action.getPropertyListResponse
        });
};
export const getPropertyListFailure = (state, action) => {
    return state.merge(
        {
            getPropertyListFetching: false,
            getPropertyListError: action.getPropertyListError
        });
};

/*---------- generatePropertyListReport --------*/


export const requestGeneratePropertyListReport = (state, action) => {
    return state.merge(
        {
            generatePropertyListReportFetching: true,
            propertyIds: action.propertyIds,
            userId: action.userId,
        });
};
export const generatePropertyListReportSuccess = (state, action) => {
    return state.merge(
        {
            generatePropertyListReportFetching: false,
            generatePropertyListReportResponse: action.generatePropertyListReportResponse,
        });
};
export const generatePropertyListReportFailure = (state, action) => {
    return state.merge(
        {
            generatePropertyListReportFetching: false,
            generatePropertyListReportError: action.generatePropertyListReportError,
        });
};

/*---------- updateBatchPropertyList --------*/
export const requestUpdateBatchPropertyList = (state, action) => {
    return state.merge(
        {
            updateBatchPropertyListFetching: true,
            batchProperty: action.batchProperty,
        });
};
export const updateBatchPropertyListSuccess = (state, action) => {
    return state.merge(
        {
            updateBatchPropertyListFetching: false,
            updateBatchPropertyListResponse: action.updateBatchPropertyListResponse,
            getPropertyListResponse: action.updateBatchPropertyListResponse
        });
};
export const updateBatchPropertyListFailure = (state, action) => {
    return state.merge(
        {
            updateBatchPropertyListFetching: false,
            updateBatchPropertyListError: action.updateBatchPropertyListError,
        });
};

/*---------- getPropertyDetail --------*/
export const requestGetPropertyDetail = (state, action) => {
    return state.merge(
        {
            getPropertyDetailFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
            category: action.category,
            updatePropertyError: null,
            getPropertyDetailResponse: null,
            getPropertyDetailError: null,
        });
};
export const getPropertyDetailSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyDetailFetching: false,
            getPropertyDetailResponse: action.getPropertyDetailResponse,
        });
};
export const getPropertyDetailFailure = (state, action) => {
    return state.merge(
        {
            getPropertyDetailFetching: false,
            getPropertyDetailError: action.getPropertyDetailError,
        });
};

/*---------- getProjectUnits --------*/
export const requestGetProjectUnits = (state, action) => {
    return state.merge(
        {
            getProjectUnitsFetching: true,
            projectId: action.projectId
        });
};
export const getProjectUnitsSuccess = (state, action) => {
    const getPropertyDetailResponse = { ...state.getPropertyDetailResponse };
    getPropertyDetailResponse.projectUnits = action.getProjectUnitsResponse;
    return state.merge(
        {
            getProjectUnitsFetching: false,
            getProjectUnitsResponse: action.getProjectUnitsResponse,
            getPropertyDetailResponse
        });
};
export const getProjectUnitsFailure = (state, action) => {
    return state.merge(
        {
            getProjectUnitsFetching: false,
            getProjectUnitsError: action.getProjectUnitsError
        });
};

/*---------- updateProperty --------*/
export const requestUpdateProperty = (state, action) => {
    return state.merge(
        {
            updatePropertyFetching: true,
            propertyDetail: action.propertyDetail,
            userId: action.userId,
            updatePropertyResponse: null,
        });
};
export const updatePropertySuccess = (state, action) => {
    return state.merge(
        {
            updatePropertyFetching: false,
            updatePropertyResponse: action.updatePropertyResponse,
            getPropertyDetailResponse: action.updatePropertyResponse,
            updatePropertyError: null
        });
};
export const updatePropertyFailure = (state, action) => {
    return state.merge(
        {
            updatePropertyFetching: false,
            updatePropertyResponse: null,
            updatePropertyError: action.updatePropertyError,
        });
};

/*---------- updatePropertySendToWeb --------*/
export const requestUpdatePropertySendToWeb = (state, action) => {
    return state.merge(
        {
            updatePropertySendToWebFetching: true,
            propertyId: action.propertyId,
            isOnWeb: action.isOnWeb,
            userId: action.userId
        });
};
export const updatePropertySendToWebSuccess = (state, action) => {
    return state.merge(
        {
            updatePropertySendToWebFetching: false,
            updatePropertySendToWebResponse: action.updatePropertySendToWebResponse,
            getPropertyDetailResponse: action.updatePropertySendToWebResponse,
        });
};
export const updatePropertySendToWebFailure = (state, action) => {
    return state.merge(
        {
            updatePropertySendToWebFetching: false,
            updatePropertySendToWebError: action.updatePropertySendToWebError,
        });
};

/*---------- updatePortalSenderForProperty --------*/
export const requestUpdatePortalSenderForProperty = (state, action) => {
    return state.merge(
        {
            updatePortalSenderForPropertyFetching: true,
            propertyId: action.propertyId,
            portalId: action.portalId,
            userId: action.userId,
            isSelected: action.isSelected
        });
};
export const updatePortalSenderForPropertySuccess = (state, action) => {
    const getPropertyDetailResponse = (state.getPropertyDetailResponse) ? Immutable.asMutable(state.getPropertyDetailResponse, { deep: true }) : null;
    if (getPropertyDetailResponse && state.portalId) {
        // update isInProgress, isSelected by portalId
        const index = R.findIndex(R.propEq('id', state.portalId))(getPropertyDetailResponse.propertyDetail.portals);
        if (index > -1) {
            getPropertyDetailResponse.propertyDetail.portals[index].isInProgress = true;
            getPropertyDetailResponse.propertyDetail.portals[index].isSelected = state.isSelected;
        }
    }
    return state.merge(
        {
            updatePortalSenderForPropertyFetching: false,
            updatePortalSenderForPropertyResponse: action.updatePortalSenderForPropertyResponse,
            getPropertyDetailResponse
        });
};
export const updatePortalSenderForPropertyFailure = (state, action) => {
    return state.merge(
        {
            updatePortalSenderForPropertyFetching: false,
            updatePortalSenderForPropertyError: action.updatePortalSenderForPropertyError,
        });
};

/*---------- updatePropertyArchive --------*/
export const requestUpdatePropertyArchive = (state, action) => {
    return state.merge(
        {
            updatePropertyArchiveFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
        });
};
export const updatePropertyArchiveSuccess = (state, action) => {
    const getPropertyDetailResponse = (state.getPropertyDetailResponse) ? Immutable.asMutable(state.getPropertyDetailResponse, { deep: true }) : null;
    if (getPropertyDetailResponse) {
        // update instorage to main object
        getPropertyDetailResponse.propertyDetail.inStorage = !getPropertyDetailResponse.propertyDetail.inStorage;
    }
    return state.merge(
        {
            updatePropertyArchiveFetching: false,
            updatePropertyArchiveResponse: action.updatePropertyArchiveResponse,
            getPropertyDetailResponse
        });
};
export const updatePropertyArchiveFailure = (state, action) => {
    return state.merge(
        {
            updatePropertyArchiveFetching: false,
            updatePropertyArchiveError: action.updatePropertyArchiveError,

        });
};

/*---------- deleteProperty --------*/
export const requestDeleteProperty = (state, action) => {
    return state.merge(
        {
            deletePropertyFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
        });
};
export const deletePropertySuccess = (state, action) => {
    return state.merge(
        {
            deletePropertyFetching: false,
            deletePropertyResponse: action.deletePropertyResponse,
        });
};
export const deletePropertyFailure = (state, action) => {
    return state.merge(
        {
            deletePropertyFetching: false,
            deletePropertyError: action.deletePropertyError,
        });
};

/*---------- generateDynamicPropertyReport --------*/
export const requestGenerateDynamicPropertyReport = (state, action) => {
    return state.merge(
        {
            generateDynamicPropertyReportFetching: true,
            reportId: action.reportId,
            methodName: action.methodName,
            propertyId: action.propertyId
        });
};
export const generateDynamicPropertyReportSuccess = (state, action) => {
    return state.merge(
        {
            generateDynamicPropertyReportFetching: false,
            generateDynamicPropertyReportResponse: action.generateDynamicPropertyReportResponse
        });
};
export const generateDynamicPropertyReportFailure = (state, action) => {
    return state.merge(
        {
            generateDynamicPropertyReportFetching: false,
            generateDynamicPropertyReportError: action.generateDynamicPropertyReportError
        });
};

/*---------- getPropertyPicturesAndFiles --------*/
export const requestGetPropertyPicturesAndFiles = (state, action) => {
    return state.merge(
        {
            getPropertyPicturesAndFilesFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
        });
};
export const getPropertyPicturesAndFilesSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyPicturesAndFilesFetching: false,
            getPropertyPicturesAndFilesResponse: action.getPropertyPicturesAndFilesResponse,
        });
};
export const getPropertyPicturesAndFilesFailure = (state, action) => {
    return state.merge(
        {
            getPropertyPicturesAndFilesFetching: false,
            getPropertyPicturesAndFilesError: action.getPropertyPicturesAndFilesError,
        });
};

/*---------- updateWaterMarkSetting --------*/
export const requestUpdateWaterMarkSetting = (state, action) => {
    return state.merge(
        {
            updateWaterMarkSettingFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
            watermarkSetting: action.watermarkSetting
        });
};
export const updateWaterMarkSettingSuccess = (state, action) => {
    return state.merge(
        {
            updateWaterMarkSettingFetching: false,
            updateWaterMarkSettingResponse: action.updateWaterMarkSettingResponse,
            getPropertyPicturesAndFilesResponse: action.updateWaterMarkSettingResponse,
        });
};
export const updateWaterMarkSettingFailure = (state, action) => {
    return state.merge(
        {
            updateWaterMarkSettingFetching: false,
            updateWaterMarkSettingError: action.updateWaterMarkSettingError,
        });
};

/*---------- getPropertyPicturesWithWaterMark --------*/
export const requestGetPropertyPicturesWithWaterMark = (state, action) => {
    return state.merge(
        {
            getPropertyPicturesWithWaterMarkFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
        });
};
export const getPropertyPicturesWithWaterMarkSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyPicturesWithWaterMarkFetching: false,
            getPropertyPicturesWithWaterMarkResponse: action.getPropertyPicturesWithWaterMarkResponse,
        });
};
export const getPropertyPicturesWithWaterMarkFailure = (state, action) => {
    return state.merge(
        {
            getPropertyPicturesWithWaterMarkFetching: false,
            getPropertyPicturesWithWaterMarkError: action.getPropertyPicturesWithWaterMarkError,
        });
};

/*---------- updatePropertyPicturesAndFiles --------*/
export const requestUpdatePropertyPicturesAndFiles = (state, action) => {
    return state.merge(
        {
            updatePropertyPicturesAndFilesFetching: true,
            propertyId: action.propertyId,
            pictureAndFiles: action.pictureAndFiles,
            userId: action.userId,
            updatePropertyPicturesAndFilesError: null
        });
};
export const updatePropertyPicturesAndFilesSuccess = (state, action) => {
    const getPropertyDetailResponse = (state.getPropertyDetailResponse) ? Immutable.asMutable(state.getPropertyDetailResponse, { deep: true }) : null;
    if (getPropertyDetailResponse && getPropertyDetailResponse.propertyDetail) {
        // update main picture to right panel component
        getPropertyDetailResponse.propertyDetail.propertyPicture = (action.updatePropertyPicturesAndFilesResponse
            && action.updatePropertyPicturesAndFilesResponse.propertyPicturesAndFilesDetail
            && action.updatePropertyPicturesAndFilesResponse.propertyPicturesAndFilesDetail.propertyPictures
            && action.updatePropertyPicturesAndFilesResponse.propertyPicturesAndFilesDetail.propertyPictures.length > 0) ?
            `${action.updatePropertyPicturesAndFilesResponse.propertyPicturesAndFilesDetail.propertyPictures[0].fileName}?${generateRandom()}` : null;
        getPropertyDetailResponse.propertyDetail.portals = action.updatePropertyPicturesAndFilesResponse.propertyPortals;
        getPropertyDetailResponse.propertyDetail.sentToWeb = action.updatePropertyPicturesAndFilesResponse.sentToWeb;
    }
    return state.merge(
        {
            updatePropertyPicturesAndFilesFetching: false,
            updatePropertyPicturesAndFilesResponse: action.updatePropertyPicturesAndFilesResponse,
            getPropertyPicturesAndFilesResponse: action.updatePropertyPicturesAndFilesResponse,
            updatePropertyPicturesAndFilesError: null,
            getPropertyDetailResponse
        });
};
export const updatePropertyPicturesAndFilesFailure = (state, action) => {
    return state.merge(
        {
            updatePropertyPicturesAndFilesFetching: false,
            updatePropertyPicturesAndFilesError: action.updatePropertyPicturesAndFilesError,
        });
};

/*---------- rotatePropertyPictures --------*/
export const requestRotatePropertyPictures = (state, action) => {
    return state.merge(
        {
            rotatePropertyPicturesFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
            angle: action.angle,
            pictureIds: action.pictureIds
        });
};
export const rotatePropertyPicturesSuccess = (state, action) => {
    return state.merge(
        {
            rotatePropertyPicturesFetching: false,
            rotatePropertyPicturesResponse: action.rotatePropertyPicturesResponse,
            getPropertyPicturesAndFilesResponse: action.rotatePropertyPicturesResponse,
        });
};
export const rotatePropertyPicturesFailure = (state, action) => {
    return state.merge(
        {
            rotatePropertyPicturesFetching: false,
            rotatePropertyPicturesError: action.rotatePropertyPicturesError,
        });
};

/*---------- updateCategory --------*/
export const requestUpdateCategory = (state, action) => {
    return state.merge(
        {
            updateCategoryFetching: true,
            propertyId: action.propertyId,
            userId: action.userId
        });
};
export const updateCategorySuccess = (state, action) => {
    return state.merge(
        {
            updateCategoryFetching: false,
            updateCategoryResponse: action.updateCategoryResponse,
        });
};
export const updateCategoryFailure = (state, action) => {
    return state.merge(
        {
            updateCategoryFetching: false,
            updateCategoryError: action.updateCategoryError,
        });
};

/*---------- convertPropertyType --------*/
export const requestConvertPropertyType = (state, action) => {
    return state.merge(
        {
            convertPropertyTypeFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
            propertyTypeId: action.propertyTypeId
        });
};
export const convertPropertyTypeSuccess = (state, action) => {
    return state.merge(
        {
            convertPropertyTypeFetching: false,
            convertPropertyTypeResponse: action.convertPropertyTypeResponse,
        });
};
export const convertPropertyTypeFailure = (state, action) => {
    return state.merge(
        {
            convertPropertyTypeFetching: false,
            convertPropertyTypeError: action.convertPropertyTypeError,
        });
};

/*---------- duplicateProperty --------*/
export const requestDuplicateProperty = (state, action) => {
    return state.merge(
        {
            duplicatePropertyFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
        });
};
export const duplicatePropertySuccess = (state, action) => {
    return state.merge(
        {
            duplicatePropertyFetching: false,
            duplicatePropertyResponse: action.duplicatePropertyResponse,
        });
};
export const duplicatePropertyFailure = (state, action) => {
    return state.merge(
        {
            duplicatePropertyFetching: false,
            duplicatePropertyError: action.duplicatePropertyError,
        });
};

/*---------- getOwnersInformation --------*/
export const requestGetOwnersInformation = (state, action) => {
    return state.merge(
        {
            getOwnersInformationFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
            getOwnersInformationError: null
        });
};
export const getOwnersInformationSuccess = (state, action) => {
    return state.merge(
        {
            getOwnersInformationFetching: false,
            getOwnersInformationResponse: action.getOwnersInformationResponse
        });
};
export const getOwnersInformationFailure = (state, action) => {
    return state.merge(
        {
            getOwnersInformationFetching: false,
            getOwnersInformationError: action.getOwnersInformationError
        });
};

/*---------- updateOwnersInformation --------*/
export const requestUpdateOwnersInformation = (state, action) => {
    return state.merge(
        {
            updateOwnersInformationFetching: true,
            updateOwnersInformationError: null,
            sellerOrBuyerInformation: action.sellerOrBuyerInformation,
            propertyId: action.propertyId,
            userId: action.userId,
            updateOwnersInformationResponse: null
        });
};
export const updateOwnersInformationSuccess = (state, action) => {
    return state.merge(
        {
            updateOwnersInformationFetching: false,
            updateOwnersInformationResponse: action.updateOwnersInformationResponse,
            getOwnersInformationResponse: action.updateOwnersInformationResponse
        });
};
export const updateOwnersInformationFailure = (state, action) => {
    return state.merge(
        {
            updateOwnersInformationFetching: false,
            updateOwnersInformationError: action.updateOwnersInformationError,
        });
};

/*---------- getPropertyActivityLogs --------*/
export const requestGetPropertyActivityLogs = (state, action) => {
    return state.merge(
        {
            getPropertyActivityLogsFetching: true,
            propertyId: action.propertyId,
            getPropertyActivityLogsError: null,
            createOrUpdatePropertyActivityLogError: null,
            removePropertyActivityLogError: null
        });
};
export const getPropertyActivityLogsSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyActivityLogsFetching: false,
            getPropertyActivityLogsResponse: action.getPropertyActivityLogsResponse,
        });
};
export const getPropertyActivityLogsFailure = (state, action) => {
    return state.merge(
        {
            getPropertyActivityLogsFetching: false,
            getPropertyActivityLogsError: action.getPropertyActivityLogsError,
        });
};

/*---------- createOrUpdatePropertyActivityLog --------*/
export const requestCreateOrUpdatePropertyActivityLog = (state, action) => {
    return state.merge(
        {
            createOrUpdatePropertyActivityLogFetching: true,
            propertyActivityDetail: action.propertyActivityDetail,
            createOrUpdatePropertyActivityLogError: null
        });
};
export const createOrUpdatePropertyActivityLogSuccess = (state, action) => {
    return state.merge(
        {
            createOrUpdatePropertyActivityLogFetching: false,
            createOrUpdatePropertyActivityLogResponse: action.createOrUpdatePropertyActivityLogResponse,
            getPropertyActivityLogsResponse: action.createOrUpdatePropertyActivityLogResponse,
        });
};
export const createOrUpdatePropertyActivityLogFailure = (state, action) => {
    return state.merge(
        {
            createOrUpdatePropertyActivityLogFetching: false,
            createOrUpdatePropertyActivityLogError: action.createOrUpdatePropertyActivityLogError,
        });
};

/*---------- removePropertyActivityLog --------*/
export const requestRemovePropertyActivityLog = (state, action) => {
    return state.merge(
        {
            removePropertyActivityLogFetching: true,
            activityLogId: action.activityLogId,
            propertyId: action.propertyId,
            removePropertyActivityLogError: null
        });
};
export const removePropertyActivityLogSuccess = (state, action) => {
    return state.merge(
        {
            removePropertyActivityLogFetching: false,
            removePropertyActivityLogResponse: action.removePropertyActivityLogResponse,
            getPropertyActivityLogsResponse: action.removePropertyActivityLogResponse,
        });
};
export const removePropertyActivityLogFailure = (state, action) => {
    return state.merge(
        {
            removePropertyActivityLogFetching: false,
            removePropertyActivityLogError: action.removePropertyActivityLogError,
        });
};

/*---------- getpropertyPortals --------*/
export const requestGetpropertyPortals = (state, action) => {
    return state.merge(
        {
            getpropertyPortalsFetching: true,
            propertyId: action.propertyId
        });
};
export const getpropertyPortalsSuccess = (state, action) => {
    const getPropertyDetailResponse = (state.getPropertyDetailResponse) ? Immutable.asMutable(state.getPropertyDetailResponse, { deep: true }) : null;
    if (getPropertyDetailResponse && getPropertyDetailResponse.propertyDetail) {
        getPropertyDetailResponse.propertyDetail.portals = action.getpropertyPortalsResponse;
    }
    return state.merge(
        {
            getpropertyPortalsFetching: false,
            getpropertyPortalsResponse: action.getpropertyPortalsResponse,
            getPropertyDetailResponse
        });
};
export const getpropertyPortalsFailure = (state, action) => {
    return state.merge(
        {
            getpropertyPortalsFetching: false,
            getpropertyPortalsError: action.getpropertyPortalsError
        });
};

/*---------- getFmrDetailResponse --------*/
export const requestGetFmrDetailResponse = (state, action) => {
    return state.merge(
        {
            getFmrDetailResponseFetching: true,
            mainRegId: action.mainRegId,
            getFmrDetailResponseError: null
        });
};
export const getFmrDetailResponseSuccess = (state, action) => {
    return state.merge(
        {
            getFmrDetailResponseFetching: false,
            getFmrDetailResponseResponse: action.getFmrDetailResponseResponse,
            getFmrDetailResponseError: null
        });
};
export const getFmrDetailResponseFailure = (state, action) => {
    return state.merge(
        {
            getFmrDetailResponseFetching: false,
            getFmrDetailResponseError: action.getFmrDetailResponseError
        });
};

/*---------- getpropertyHistories --------*/
export const requestGetpropertyHistories = (state, action) => {
    return state.merge(
        {
            getpropertyHistoriesFetching: true,
            propertyId: action.propertyId,
            getpropertyHistoriesError: null,
            getpropertyHistoriesResponse: null,
            restorePropertyHistoryError: null
        });
};
export const getpropertyHistoriesSuccess = (state, action) => {
    return state.merge(
        {
            getpropertyHistoriesFetching: false,
            getpropertyHistoriesResponse: action.getpropertyHistoriesResponse,
        });
};

export const getpropertyHistoriesFailure = (state, action) => {
    return state.merge(
        {
            getpropertyHistoriesFetching: false,
            getpropertyHistoriesError: action.getpropertyHistoriesError
        });
};

/*---------- restorePropertyHistory --------*/
export const requestRestorePropertyHistory = (state, action) => {
    return state.merge(
        {
            restorePropertyHistoryFetching: true,
            propertyId: action.propertyId,
            propertyShwId: action.propertyShwId,
            userId: action.userId
        });
};
export const restorePropertyHistorySuccess = (state, action) => {
    return state.merge(
        {
            restorePropertyHistoryFetching: false,
            restorePropertyHistoryResponse: action.restorePropertyHistoryResponse
        });
};
export const restorePropertyHistoryFailure = (state, action) => {
    return state.merge(
        {
            restorePropertyHistoryFetching: false,
            restorePropertyHistoryError: action.restorePropertyHistoryError,
        });
};

export const requestGetPropertyDocument = (state, action) => {
    return state.merge(
        {
            getPropertyDocumentFetching: true,
            propertyId: action.propertyId,
            getPropertyDocumentResponse: null,
            getPropertyDocumentError: null,
            removeDocumentError: null,
            duplicateOfferError: null,
            downloadPropertyFileError: null,
            updatePropertyDocumentError: null,
        });
};
export const getPropertyDocumentSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyDocumentFetching: false,
            getPropertyDocumentResponse: action.getPropertyDocumentResponse,
            getPropertyDocumentError: null,
            removeDocumentError: null,
            duplicateOfferError: null,
            downloadPropertyFileError: null,
            updatePropertyDocumentError: null,

        });
};
export const getPropertyDocumentFailure = (state, action) => {
    return state.merge(
        {
            getPropertyDocumentFetching: false,
            getPropertyDocumentError: action.getPropertyDocumentError,

        });
};

/*---------- updatePropertyDocument --------*/
export const requestUpdatePropertyDocument = (state, action) => {
    return state.merge(
        {
            updatePropertyDocumentFetching: true,
            propertyId: action.propertyId,
            documents: action.documents,
            updatePropertyDocumentResponse: null,
            updatePropertyDocumentError: null,
            removeDocumentError: null,
            duplicateOfferError: null,
            downloadPropertyFileError: null,

        });
};
export const updatePropertyDocumentSuccess = (state, action) => {
    return state.merge(
        {
            updatePropertyDocumentFetching: false,
            updatePropertyDocumentResponse: action.updatePropertyDocumentResponse,
            updatePropertyDocumentError: null,
            removeDocumentError: null,
            duplicateOfferError: null,
            downloadPropertyFileError: null,

        });
};
export const updatePropertyDocumentFailure = (state, action) => {
    return state.merge(
        {
            updatePropertyDocumentFetching: false,
            updatePropertyDocumentError: action.updatePropertyDocumentError,

        });
};

/*---------- removeDocument --------*/
export const requestRemoveDocument = (state, action) => {
    return state.merge(
        {
            removeDocumentFetching: true,
            propertyId: action.propertyId,
            referenceId: action.referenceId,
            actionId: action.actionId,
            documentType: action.documentType,
            removeDocumentResponse: null,
            removeDocumentError: null,
            duplicateOfferError: null,
            downloadPropertyFileError: null,
            updatePropertyDocumentError: null,
        });
};
export const removeDocumentSuccess = (state, action) => {
    return state.merge(
        {
            removeDocumentFetching: false,
            removeDocumentResponse: action.removeDocumentResponse,
            removeDocumentError: null,
            duplicateOfferError: null,
            downloadPropertyFileError: null,
            updatePropertyDocumentError: null,
        });
};

export const removeDocumentFailure = (state, action) => {
    return state.merge(
        {
            removeDocumentFetching: false,
            removeDocumentError: action.removeDocumentError,

        });
};

/*---------- duplicateOffer --------*/
export const requestDuplicateOffer = (state, action) => {
    return state.merge(
        {
            duplicateOfferFetching: true,
            propertyId: action.propertyId,
            offerId: action.offerId,
            duplicateOfferResponse: null,
            duplicateOfferError: null,
            removeDocumentError: null,
            downloadPropertyFileError: null,
            updatePropertyDocumentError: null,
        });
};
export const duplicateOfferSuccess = (state, action) => {
    return state.merge(
        {
            duplicateOfferFetching: false,
            duplicateOfferResponse: action.duplicateOfferResponse,
            duplicateOfferError: null,
            removeDocumentError: null,
            downloadPropertyFileError: null,
            updatePropertyDocumentError: null,

        });
};
export const duplicateOfferFailure = (state, action) => {
    return state.merge(
        {
            duplicateOfferFetching: false,
            duplicateOfferError: action.duplicateOfferError,

        });
};

/*---------- downloadPropertyFile --------*/
export const requestDownloadPropertyFile = (state, action) => {
    return state.merge(
        {
            downloadPropertyFileFetching: true,
            propertyFileId: action.propertyFileId,
            downloadPropertyFileResponse: null,
            downloadPropertyFileError: null,
            removeDocumentError: null,
            duplicateOfferError: null,
            updatePropertyDocumentError: null,

        });
};

export const downloadPropertyFileSuccess = (state, action) => {
    return state.merge(
        {
            downloadPropertyFileFetching: false,
            downloadPropertyFileResponse: action.downloadPropertyFileResponse,
            downloadPropertyFileError: null,
            removeDocumentError: null,
            duplicateOfferError: null,
            updatePropertyDocumentError: null,

        });
};
export const downloadPropertyFileFailure = (state, action) => {
    return state.merge(
        {
            downloadPropertyFileFetching: false,
            downloadPropertyFileError: action.downloadPropertyFileError,

        });
};

/*---------- getPropertyLoans --------*/

export const requestGetPropertyLoans = (state, action) => {
    return state.merge(
        {
            getPropertyLoansFetching: true,
            propertyId: action.propertyId,
            getPropertyLoansResponse: null,
            getPropertyLoansError: null,
            getPropertyLoanDetailError: null,
            savePropertyLoanError: null,
            removePropertyLoanError: null,
            updatePropertyLoanIsSentError: null,
        });
};
export const getPropertyLoansSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyLoansFetching: false,
            getPropertyLoansResponse: action.getPropertyLoansResponse,

        });
};
export const getPropertyLoansFailure = (state, action) => {
    return state.merge(
        {
            getPropertyLoansFetching: false,
            getPropertyLoansError: action.getPropertyLoansError,

        });
};

/*---------- getPropertyLoanDetail --------*/

export const requestGetPropertyLoanDetail = (state, action) => {
    return state.merge(
        {
            getPropertyLoanDetailFetching: true,
            propertyId: action.propertyId,
            loanId: action.loanId,
            getPropertyLoanDetailResponse: null,
            getPropertyLoanDetailError: null,
            getPropertyLoansError: null,
            savePropertyLoanError: null,
            removePropertyLoanError: null,
            updatePropertyLoanIsSentError: null,
        });
};

export const getPropertyLoanDetailSuccess = (state, action) => {
    return state.merge(
        {
            getPropertyLoanDetailFetching: false,
            getPropertyLoanDetailResponse: action.getPropertyLoanDetailResponse,

        });
};
export const getPropertyLoanDetailFailure = (state, action) => {
    return state.merge(
        {
            getPropertyLoanDetailFetching: false,
            getPropertyLoanDetailError: action.getPropertyLoanDetailError,

        });
};

/*---------- savePropertyLoan --------*/

export const requestSavePropertyLoan = (state, action) => {
    return state.merge(
        {
            savePropertyLoanFetching: true,
            propertyId: action.propertyId,
            mortgage: action.mortgage,
            savePropertyLoanResponse: null,
            savePropertyLoanError: null,
            getPropertyLoansError: null,
            getPropertyLoanDetailError: null,
            removePropertyLoanError: null,
            updatePropertyLoanIsSentError: null,
        });
};
export const savePropertyLoanSuccess = (state, action) => {
    return state.merge(
        {
            savePropertyLoanFetching: false,
            savePropertyLoanResponse: action.savePropertyLoanResponse,

        });
};
export const savePropertyLoanFailure = (state, action) => {
    return state.merge(
        {
            savePropertyLoanFetching: false,
            savePropertyLoanError: action.savePropertyLoanError,

        });
};

/*---------- removePropertyLoan --------*/

export const requestRemovePropertyLoan = (state, action) => {
    return state.merge(
        {
            removePropertyLoanFetching: true,
            propertyId: action.propertyId,
            loanId: action.loanId,
            removePropertyLoanResponse: null,
            removePropertyLoanError: null,
            getPropertyLoansError: null,
            getPropertyLoanDetailError: null,
            savePropertyLoanError: null,
            updatePropertyLoanIsSentError: null,
        });
};
export const removePropertyLoanSuccess = (state, action) => {
    return state.merge(
        {
            removePropertyLoanFetching: false,
            removePropertyLoanResponse: action.removePropertyLoanResponse,

        });
};
export const removePropertyLoanFailure = (state, action) => {
    return state.merge(
        {
            removePropertyLoanFetching: false,
            removePropertyLoanError: action.removePropertyLoanError,

        });
};

/*---------- updatePropertyLoanIsSent --------*/

export const requestUpdatePropertyLoanIsSent = (state, action) => {
    return state.merge(
        {
            updatePropertyLoanIsSentFetching: true,
            propertyId: action.propertyId,
            loanId: action.loanId,
            isSent: action.isSent,
            updatePropertyLoanIsSentResponse: null,
            updatePropertyLoanIsSentError: null,
            getPropertyLoansError: null,
            getPropertyLoanDetailError: null,
            savePropertyLoanError: null,
            removePropertyLoanError: null,
        });
};
export const updatePropertyLoanIsSentSuccess = (state, action) => {
    return state.merge(
        {
            updatePropertyLoanIsSentFetching: false,
            updatePropertyLoanIsSentResponse: action.updatePropertyLoanIsSentResponse,

        });
};
export const updatePropertyLoanIsSentFailure = (state, action) => {
    return state.merge(
        {
            updatePropertyLoanIsSentFetching: false,
            updatePropertyLoanIsSentError: action.updatePropertyLoanIsSentError,

        });
};

/*---------- addPropertyViews --------*/

export const requestAddPropertyViews = (state, action) => {
    return state.merge(
        {
            addPropertyViewsFetching: true,
            userId: action.userId,
            propertyId: action.propertyId,
        });
};
export const addPropertyViewsSuccess = (state, action) => {
    return state.merge(
        {
            addPropertyViewsFetching: false,
            addPropertyViewsResponse: action.addPropertyViewsResponse,

        });
};
export const addPropertyViewsFailure = (state, action) => {
    return state.merge(
        {
            addPropertyViewsFetching: false,
            addPropertyViewsError: action.addPropertyViewsError,

        });
};

/*---------- downloadPropertyPictures --------*/


export const requestDownloadPropertyPictures = (state, action) => {
    return state.merge(
        {
            downloadPropertyPicturesFetching: true,
            propertyPictureIds: action.propertyPictureIds,
            propertyId: action.propertyId,
            downloadPropertyPicturesResponse: null,
            downloadPropertyPicturesError: null
        });
};
export const downloadPropertyPicturesSuccess = (state, action) => {
    return state.merge(
        {
            downloadPropertyPicturesFetching: false,
            downloadPropertyPicturesResponse: action.downloadPropertyPicturesResponse
        });
};
export const downloadPropertyPicturesFailure = (state, action) => {
    return state.merge(
        {
            downloadPropertyPicturesFetching: false,
            downloadPropertyPicturesError: action.downloadPropertyPicturesError
        });
};


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

    /*---------- propertyActions --------*/
    [Types.REQUEST_PROPERTY_ACTIONS]: requestPropertyActions,
    [Types.PROPERTY_ACTIONS_SUCCESS]: propertyActionsSuccess,
    [Types.PROPERTY_ACTIONS_FAILURE]: propertyActionsFailure,

    /*---------- getLatestPropertiesView --------*/
    [Types.REQUEST_GET_LATEST_PROPERTIES_VIEW]: requestGetLatestPropertiesView,
    [Types.GET_LATEST_PROPERTIES_VIEW_SUCCESS]: getLatestPropertiesViewSuccess,
    [Types.GET_LATEST_PROPERTIES_VIEW_FAILURE]: getLatestPropertiesViewFailure,

    /*---------- updatePropertyStatus --------*/
    [Types.REQUEST_UPDATE_PROPERTY_STATUS]: requestUpdatePropertyStatus,
    [Types.UPDATE_PROPERTY_STATUS_SUCCESS]: updatePropertyStatusSuccess,
    [Types.UPDATE_PROPERTY_STATUS_FAILURE]: updatePropertyStatusFailure,

    /*---------- getPropertyDescription --------*/
    [Types.REQUEST_GET_PROPERTY_DESCRIPTION]: requestGetPropertyDescription,
    [Types.GET_PROPERTY_DESCRIPTION_SUCCESS]: getPropertyDescriptionSuccess,
    [Types.GET_PROPERTY_DESCRIPTION_FAILURE]: getPropertyDescriptionFailure,

    /*---------- updateStandardText --------*/
    [Types.REQUEST_UPDATE_STANDARD_TEXT]: requestUpdateStandardText,
    [Types.UPDATE_STANDARD_TEXT_SUCCESS]: updateStandardTextSuccess,
    [Types.UPDATE_STANDARD_TEXT_FAILURE]: updateStandardTextFailure,

    /*---------- updatePropertyDescription --------*/
    [Types.REQUEST_UPDATE_PROPERTY_DESCRIPTION]: requestUpdatePropertyDescription,
    [Types.UPDATE_PROPERTY_DESCRIPTION_SUCCESS]: updatePropertyDescriptionSuccess,
    [Types.UPDATE_PROPERTY_DESCRIPTION_FAILURE]: updatePropertyDescriptionFailure,

    /*---------- getPropertyList --------*/
    [Types.REQUEST_GET_PROPERTY_LIST]: requestGetPropertyList,
    [Types.GET_PROPERTY_LIST_SUCCESS]: getPropertyListSuccess,
    [Types.GET_PROPERTY_LIST_FAILURE]: getPropertyListFailure,

    /*---------- generatePropertyListReport --------*/
    [Types.REQUEST_GENERATE_PROPERTY_LIST_REPORT]: requestGeneratePropertyListReport,
    [Types.GENERATE_PROPERTY_LIST_REPORT_SUCCESS]: generatePropertyListReportSuccess,
    [Types.GENERATE_PROPERTY_LIST_REPORT_FAILURE]: generatePropertyListReportFailure,

    /*---------- updateBatchPropertyList --------*/
    [Types.REQUEST_UPDATE_BATCH_PROPERTY_LIST]: requestUpdateBatchPropertyList,
    [Types.UPDATE_BATCH_PROPERTY_LIST_SUCCESS]: updateBatchPropertyListSuccess,
    [Types.UPDATE_BATCH_PROPERTY_LIST_FAILURE]: updateBatchPropertyListFailure,

    /*---------- getPropertyDetail --------*/
    [Types.REQUEST_GET_PROPERTY_DETAIL]: requestGetPropertyDetail,
    [Types.GET_PROPERTY_DETAIL_SUCCESS]: getPropertyDetailSuccess,
    [Types.GET_PROPERTY_DETAIL_FAILURE]: getPropertyDetailFailure,

    /*---------- getProjectUnits --------*/
    [Types.REQUEST_GET_PROJECT_UNITS]: requestGetProjectUnits,
    [Types.GET_PROJECT_UNITS_SUCCESS]: getProjectUnitsSuccess,
    [Types.GET_PROJECT_UNITS_FAILURE]: getProjectUnitsFailure,

    /*---------- updateProperty --------*/
    [Types.REQUEST_UPDATE_PROPERTY]: requestUpdateProperty,
    [Types.UPDATE_PROPERTY_SUCCESS]: updatePropertySuccess,
    [Types.UPDATE_PROPERTY_FAILURE]: updatePropertyFailure,

    /*---------- updatePropertySendToWeb --------*/
    [Types.REQUEST_UPDATE_PROPERTY_SEND_TO_WEB]: requestUpdatePropertySendToWeb,
    [Types.UPDATE_PROPERTY_SEND_TO_WEB_SUCCESS]: updatePropertySendToWebSuccess,
    [Types.UPDATE_PROPERTY_SEND_TO_WEB_FAILURE]: updatePropertySendToWebFailure,

    /*---------- updatePortalSenderForProperty --------*/
    [Types.REQUEST_UPDATE_PORTAL_SENDER_FOR_PROPERTY]: requestUpdatePortalSenderForProperty,
    [Types.UPDATE_PORTAL_SENDER_FOR_PROPERTY_SUCCESS]: updatePortalSenderForPropertySuccess,
    [Types.UPDATE_PORTAL_SENDER_FOR_PROPERTY_FAILURE]: updatePortalSenderForPropertyFailure,

    /*---------- updatePropertyArchive --------*/
    [Types.REQUEST_UPDATE_PROPERTY_ARCHIVE]: requestUpdatePropertyArchive,
    [Types.UPDATE_PROPERTY_ARCHIVE_SUCCESS]: updatePropertyArchiveSuccess,
    [Types.UPDATE_PROPERTY_ARCHIVE_FAILURE]: updatePropertyArchiveFailure,

    /*---------- deleteProperty --------*/
    [Types.REQUEST_DELETE_PROPERTY]: requestDeleteProperty,
    [Types.DELETE_PROPERTY_SUCCESS]: deletePropertySuccess,
    [Types.DELETE_PROPERTY_FAILURE]: deletePropertyFailure,

    /*---------- generateDynamicPropertyReport --------*/
    [Types.REQUEST_GENERATE_DYNAMIC_PROPERTY_REPORT]: requestGenerateDynamicPropertyReport,
    [Types.GENERATE_DYNAMIC_PROPERTY_REPORT_SUCCESS]: generateDynamicPropertyReportSuccess,
    [Types.GENERATE_DYNAMIC_PROPERTY_REPORT_FAILURE]: generateDynamicPropertyReportFailure,

    /*---------- getPropertyPicturesAndFiles --------*/
    [Types.REQUEST_GET_PROPERTY_PICTURES_AND_FILES]: requestGetPropertyPicturesAndFiles,
    [Types.GET_PROPERTY_PICTURES_AND_FILES_SUCCESS]: getPropertyPicturesAndFilesSuccess,
    [Types.GET_PROPERTY_PICTURES_AND_FILES_FAILURE]: getPropertyPicturesAndFilesFailure,

    /*---------- updateWaterMarkSetting --------*/
    [Types.REQUEST_UPDATE_WATER_MARK_SETTING]: requestUpdateWaterMarkSetting,
    [Types.UPDATE_WATER_MARK_SETTING_SUCCESS]: updateWaterMarkSettingSuccess,
    [Types.UPDATE_WATER_MARK_SETTING_FAILURE]: updateWaterMarkSettingFailure,

    /*---------- getPropertyPicturesWithWaterMark --------*/
    [Types.REQUEST_GET_PROPERTY_PICTURES_WITH_WATER_MARK]: requestGetPropertyPicturesWithWaterMark,
    [Types.GET_PROPERTY_PICTURES_WITH_WATER_MARK_SUCCESS]: getPropertyPicturesWithWaterMarkSuccess,
    [Types.GET_PROPERTY_PICTURES_WITH_WATER_MARK_FAILURE]: getPropertyPicturesWithWaterMarkFailure,

    /*---------- updatePropertyPicturesAndFiles --------*/
    [Types.REQUEST_UPDATE_PROPERTY_PICTURES_AND_FILES]: requestUpdatePropertyPicturesAndFiles,
    [Types.UPDATE_PROPERTY_PICTURES_AND_FILES_SUCCESS]: updatePropertyPicturesAndFilesSuccess,
    [Types.UPDATE_PROPERTY_PICTURES_AND_FILES_FAILURE]: updatePropertyPicturesAndFilesFailure,

    /*---------- rotatePropertyPictures --------*/
    [Types.REQUEST_ROTATE_PROPERTY_PICTURES]: requestRotatePropertyPictures,
    [Types.ROTATE_PROPERTY_PICTURES_SUCCESS]: rotatePropertyPicturesSuccess,
    [Types.ROTATE_PROPERTY_PICTURES_FAILURE]: rotatePropertyPicturesFailure,

    /*---------- updateCategory --------*/
    [Types.REQUEST_UPDATE_CATEGORY]: requestUpdateCategory,
    [Types.UPDATE_CATEGORY_SUCCESS]: updateCategorySuccess,
    [Types.UPDATE_CATEGORY_FAILURE]: updateCategoryFailure,

    /*---------- convertPropertyType --------*/
    [Types.REQUEST_CONVERT_PROPERTY_TYPE]: requestConvertPropertyType,
    [Types.CONVERT_PROPERTY_TYPE_SUCCESS]: convertPropertyTypeSuccess,
    [Types.CONVERT_PROPERTY_TYPE_FAILURE]: convertPropertyTypeFailure,

    /*---------- duplicateProperty --------*/
    [Types.REQUEST_DUPLICATE_PROPERTY]: requestDuplicateProperty,
    [Types.DUPLICATE_PROPERTY_SUCCESS]: duplicatePropertySuccess,
    [Types.DUPLICATE_PROPERTY_FAILURE]: duplicatePropertyFailure,

    /*---------- getOwnersInformation --------*/
    [Types.REQUEST_GET_OWNERS_INFORMATION]: requestGetOwnersInformation,
    [Types.GET_OWNERS_INFORMATION_SUCCESS]: getOwnersInformationSuccess,
    [Types.GET_OWNERS_INFORMATION_FAILURE]: getOwnersInformationFailure,

    /*---------- updateOwnersInformation --------*/
    [Types.REQUEST_UPDATE_OWNERS_INFORMATION]: requestUpdateOwnersInformation,
    [Types.UPDATE_OWNERS_INFORMATION_SUCCESS]: updateOwnersInformationSuccess,
    [Types.UPDATE_OWNERS_INFORMATION_FAILURE]: updateOwnersInformationFailure,

    /*---------- getPropertyActivityLogs --------*/
    [Types.REQUEST_GET_PROPERTY_ACTIVITY_LOGS]: requestGetPropertyActivityLogs,
    [Types.GET_PROPERTY_ACTIVITY_LOGS_SUCCESS]: getPropertyActivityLogsSuccess,
    [Types.GET_PROPERTY_ACTIVITY_LOGS_FAILURE]: getPropertyActivityLogsFailure,

    /*---------- createOrUpdatePropertyActivityLog --------*/
    [Types.REQUEST_CREATE_OR_UPDATE_PROPERTY_ACTIVITY_LOG]: requestCreateOrUpdatePropertyActivityLog,
    [Types.CREATE_OR_UPDATE_PROPERTY_ACTIVITY_LOG_SUCCESS]: createOrUpdatePropertyActivityLogSuccess,
    [Types.CREATE_OR_UPDATE_PROPERTY_ACTIVITY_LOG_FAILURE]: createOrUpdatePropertyActivityLogFailure,

    /*---------- removePropertyActivityLog --------*/
    [Types.REQUEST_REMOVE_PROPERTY_ACTIVITY_LOG]: requestRemovePropertyActivityLog,
    [Types.REMOVE_PROPERTY_ACTIVITY_LOG_SUCCESS]: removePropertyActivityLogSuccess,
    [Types.REMOVE_PROPERTY_ACTIVITY_LOG_FAILURE]: removePropertyActivityLogFailure,

    /*---------- getpropertyPortals --------*/
    [Types.REQUEST_GETPROPERTY_PORTALS]: requestGetpropertyPortals,
    [Types.GETPROPERTY_PORTALS_SUCCESS]: getpropertyPortalsSuccess,
    [Types.GETPROPERTY_PORTALS_FAILURE]: getpropertyPortalsFailure,

    /*---------- getPropertyDocument --------*/

    [Types.REQUEST_GET_PROPERTY_DOCUMENT]: requestGetPropertyDocument,
    [Types.GET_PROPERTY_DOCUMENT_SUCCESS]: getPropertyDocumentSuccess,
    [Types.GET_PROPERTY_DOCUMENT_FAILURE]: getPropertyDocumentFailure,

    /*---------- updatePropertyDocument --------*/

    [Types.REQUEST_UPDATE_PROPERTY_DOCUMENT]: requestUpdatePropertyDocument,
    [Types.UPDATE_PROPERTY_DOCUMENT_SUCCESS]: updatePropertyDocumentSuccess,
    [Types.UPDATE_PROPERTY_DOCUMENT_FAILURE]: updatePropertyDocumentFailure,

    /*---------- removeDocument --------*/

    [Types.REQUEST_REMOVE_DOCUMENT]: requestRemoveDocument,
    [Types.REMOVE_DOCUMENT_SUCCESS]: removeDocumentSuccess,
    [Types.REMOVE_DOCUMENT_FAILURE]: removeDocumentFailure,

    /*---------- duplicateOffer --------*/

    [Types.REQUEST_DUPLICATE_OFFER]: requestDuplicateOffer,
    [Types.DUPLICATE_OFFER_SUCCESS]: duplicateOfferSuccess,
    [Types.DUPLICATE_OFFER_FAILURE]: duplicateOfferFailure,

    /*---------- downloadPropertyFile --------*/

    [Types.REQUEST_DOWNLOAD_PROPERTY_FILE]: requestDownloadPropertyFile,
    [Types.DOWNLOAD_PROPERTY_FILE_SUCCESS]: downloadPropertyFileSuccess,
    [Types.DOWNLOAD_PROPERTY_FILE_FAILURE]: downloadPropertyFileFailure,

    /*---------- getFmrDetailResponse --------*/
    [Types.REQUEST_GET_FMR_DETAIL_RESPONSE]: requestGetFmrDetailResponse,
    [Types.GET_FMR_DETAIL_RESPONSE_SUCCESS]: getFmrDetailResponseSuccess,
    [Types.GET_FMR_DETAIL_RESPONSE_FAILURE]: getFmrDetailResponseFailure,

    /*---------- getpropertyHistories --------*/
    [Types.REQUEST_GETPROPERTY_HISTORIES]: requestGetpropertyHistories,
    [Types.GETPROPERTY_HISTORIES_SUCCESS]: getpropertyHistoriesSuccess,
    [Types.GETPROPERTY_HISTORIES_FAILURE]: getpropertyHistoriesFailure,

    /*---------- restorePropertyHistory --------*/
    [Types.REQUEST_RESTORE_PROPERTY_HISTORY]: requestRestorePropertyHistory,
    [Types.RESTORE_PROPERTY_HISTORY_SUCCESS]: restorePropertyHistorySuccess,
    [Types.RESTORE_PROPERTY_HISTORY_FAILURE]: restorePropertyHistoryFailure,

    /*---------- getPropertyLoans --------*/
    [Types.REQUEST_GET_PROPERTY_LOANS]: requestGetPropertyLoans,
    [Types.GET_PROPERTY_LOANS_SUCCESS]: getPropertyLoansSuccess,
    [Types.GET_PROPERTY_LOANS_FAILURE]: getPropertyLoansFailure,

    /*---------- getPropertyLoanDetail --------*/
    [Types.REQUEST_GET_PROPERTY_LOAN_DETAIL]: requestGetPropertyLoanDetail,
    [Types.GET_PROPERTY_LOAN_DETAIL_SUCCESS]: getPropertyLoanDetailSuccess,
    [Types.GET_PROPERTY_LOAN_DETAIL_FAILURE]: getPropertyLoanDetailFailure,

    /*---------- savePropertyLoan --------*/
    [Types.REQUEST_SAVE_PROPERTY_LOAN]: requestSavePropertyLoan,
    [Types.SAVE_PROPERTY_LOAN_SUCCESS]: savePropertyLoanSuccess,
    [Types.SAVE_PROPERTY_LOAN_FAILURE]: savePropertyLoanFailure,

    /*---------- removePropertyLoan --------*/
    [Types.REQUEST_REMOVE_PROPERTY_LOAN]: requestRemovePropertyLoan,
    [Types.REMOVE_PROPERTY_LOAN_SUCCESS]: removePropertyLoanSuccess,
    [Types.REMOVE_PROPERTY_LOAN_FAILURE]: removePropertyLoanFailure,


    /*---------- updatePropertyLoanIsSent --------*/
    [Types.REQUEST_UPDATE_PROPERTY_LOAN_IS_SENT]: requestUpdatePropertyLoanIsSent,
    [Types.UPDATE_PROPERTY_LOAN_IS_SENT_SUCCESS]: updatePropertyLoanIsSentSuccess,
    [Types.UPDATE_PROPERTY_LOAN_IS_SENT_FAILURE]: updatePropertyLoanIsSentFailure,

    /*---------- addPropertyViews --------*/
    [Types.REQUEST_ADD_PROPERTY_VIEWS]: requestAddPropertyViews,
    [Types.ADD_PROPERTY_VIEWS_SUCCESS]: addPropertyViewsSuccess,
    [Types.ADD_PROPERTY_VIEWS_FAILURE]: addPropertyViewsFailure,

    /*---------- downloadPropertyPictures --------*/
    [Types.REQUEST_DOWNLOAD_PROPERTY_PICTURES]: requestDownloadPropertyPictures,
    [Types.DOWNLOAD_PROPERTY_PICTURES_SUCCESS]: downloadPropertyPicturesSuccess,
    [Types.DOWNLOAD_PROPERTY_PICTURES_FAILURE]: downloadPropertyPicturesFailure,

});



// WEBPACK FOOTER //
// ./src/redux/sagaProperty/sagaPropertyRedux.ts